import { PowerAtlas } from "./pages/Dashboard/Atlas/Atlas";
import { BankingAnalytics } from "./pages/Dashboard/BankingAnalytics/BankingAalytics";
import { MarketMontoring } from "./pages/Dashboard/MarketMonitoring/MarketMonitoring";
import { BetaConsumption } from "./pages/Dashboard/Consumption/BetaConsumption";
import { Exchange3 } from "./pages/Dashboard/Exchange3/Exchange3";
import { Discom } from "./pages/Dashboard/Discom/Discom";
import { ExchangeComparion } from "./pages/Dashboard/Exchange3/Comparison";
import { ExchangeComparion2 } from "./pages/Dashboard/Exchange3/Comparison2";
import { AuctionPage } from "./pages/Dashboard/Auction/Auction";
import { GasPage } from "./pages/Dashboard/Gas/GasPage";
import DemandForecast from "./pages/Dashboard/DemandForecast/DemandForecast";
import { Rajasthan } from "./pages/Rajasthan/Rajasthan";
import { RajProcurement } from "./pages/Rajasthan/ProcurementTable/Procurement.jsx";
import { DemoRajProcurement } from "./pages/DemoState/ProcurementTable/Procurement.jsx";
import { RajasthanOverview } from "./pages/Rajasthan/Overview/Overview";
import { DemoRajasthanOverview } from "./pages/DemoState/Overview/Overview";
import { RajGeneration } from "./pages/Rajasthan/Generation/Generation";
import { DemoRajGeneration } from "./pages/DemoState/Generation/Generation";
import { RajDemand } from "./pages/Rajasthan/Demand/Demand";
import { CgsDemand } from "./pages/Chhattisgarh/Demand/Demand";
import { DemoRajDemand } from "./pages/DemoState/Demand/Demand";
import { RajPowerProcurement } from "./pages/Rajasthan/Procurement/PowerProcurement";
import { DemoRajPowerProcurement } from "./pages/DemoState/Procurement/PowerProcurement";
import UploadFile from "./pages/Gridco/UploadFile.jsx";
import { RajAutomation } from "./pages/Rajasthan/Automation/Automation";
import { DemoRajAutomation } from "./pages/DemoState/Automation/Automation";
import { GridcoDemand } from "./pages/Gridco/Demand/Demand";
import GridcoUploadFile from "./pages/Gridco/UploadFile.jsx";
import { GridcoGenration } from "./pages/Gridco/Genration/Genration";
import { HppcDemand } from "./pages/Hppc/Demand/Demand";
import HaryanaOverview from "./pages/Hppc/Overview/Overview";
import { HppcProcurement } from "./pages/Hppc/Procurement/Procurement";
import PriceForecastWrapper from "./pages/Dashboard/PriceForcating/PriceForecastWrapper";
import { HppcWeather } from "./pages/Hppc/Weather/WeatherWrapper";
import { RajAuctionPage } from "./pages/Rajasthan/Auction/Auction";
import { DemoRajAuctionPage } from "./pages/DemoState/Auction/Auction";
import { RajExchange3 } from "./pages/Rajasthan/Exchange3/Exchange3";
import { DemoRajExchange3 } from "./pages/DemoState/Exchange3/Exchange3";
import { ExchangeMetricsPage } from "./pages/Rajasthan/PriceAnalysis/PriceAnalysis";
import { ExchangeMetrics } from "./pages/Dashboard/NewExchnage/PriceAnalysis/PriceAnalysis";
import MainTraderComponent from "./pages/MainTraderComponent/MainTraderComponent";
import AgentHistory from "./pages/Rajasthan/Agent/AgentHistory";
import DemoUploadComponent from "./pages/DemoState/Upload/UploadComponent";
import { GridcoPowerProcurement } from "./pages/Gridco/Procurment/PowerProcurement";
import { GridcoOverviewTab } from "./pages/Gridco/Overview/Overview";
import GridcoNetSchedule from "./pages/Gridco/Automation/NetSchedule/NetIndex";
import { GridcoExchange } from "./pages/Gridco/Exchange3/Exchange3";
import { Automation } from "./pages/Gridco/Automation/Automation";
import DamPerformanceUpload from "./pages/Gridco/Automation/DamPerformance/DamPerformance";
import UploadComponent from "./pages/Rajasthan/Upload/UploadComponent";
import { Gridco } from "./pages/Gridco/Gridco";
import Consumption from "./pages/Dashboard/NewConsumption/Index";
import MeritEngineGridcoRouter from "./pages/Gridco/MeritOrderDispatch/MeritEngineRouter";
import MeritEngineCgsRouter from "./pages/Chhattisgarh/MeritOrderDispatchUpdated/MeritEngineRouter";
import MeritEngineDemoRouter from "./pages/DemoState/MeritOrderDispatch/MeritEngineRouter";
import MeritEngineRuvnlRouter from "./pages/Rajasthan/MeritOrderDispatch/MeritEngineRouter";
import GnaOptimizerRuvnl from "./pages/Rajasthan/GnaTGnaOptimizer/OptimizerRouter";
import GnaOptimizerGridco from "./pages/Gridco/GnaTGnaOptimizer/OptimizerRouter";
import GnaOptimizerDemo from "./pages/DemoState/GnaTGnaOptimizer/OptimizerRouter";
import { MarketDerivativePage } from "./pages/market-derivative/MarketDerivativePage";
import NewHPPCExchange from "./pages/Dashboard/NewExchnage";
import NewRUVNLExchange from "./pages/Dashboard/NewExchnage";
import NewCGSExchange from "./pages/Dashboard/NewExchnage";
import NewGRIDCOExchange from "./pages/Dashboard/NewExchnage";
import NewDEMOExchange from "./pages/Dashboard/NewExchnage";
import NewDASHBOARDExchange from "./pages/Dashboard/NewExchnage";
import ProcurementDemoOptimization from "./pages/DemoState/ProcurementOptimization/OptimizerRouter";
import ProcurementRuvnlOptimization from "./pages/Rajasthan/ProcurementOptimization/OptimizerRouter";
import ProcurementGridcoOptimization from "./pages/Gridco/ProcurementOptimization/OptimizerRouter";
import SurplusDeficity from "./pages/Hppc/SurplusDeficit/OptimizerRouter";
import PowerAnalyticsIndex from "./pages/Dashboard/PowerAnalytics/PowerAnalyticsDas";
import DownloadData from "./pages/Gridco/DownloadData/DownloadData";
import DownloadDataWrapper from "./pages/Gridco/DownloadData/DownloadDataWrapper";
import { JvvnlGeneration } from "./pages/Jvvnl/Generation/Generation";
import { JvvnlForecast } from "./pages/Jvvnl/ForecastAdjustment/Forcast";
import { CgsRealtime } from "./pages/Chhattisgarh/Realtime/Realtime";
import { JvvnlOverviewTab } from "./pages/Jvvnl/Demand/Demand";

export const DashboardRoutes = [
  {
    path: "marketmonitoring",
    element: <MarketMontoring />,
    noDefaultPadding: true,
  },
  {
    path: "bankingAnalytics",
    element: <BankingAnalytics />,
  },
  {
    path: "discomAnalysis",
    element: <Discom />,
    noDefaultPadding: true,
  },
  {
    path: "consumptionAndGenerationAnalytics",
    element: <Consumption />,
    noDefaultPadding: true,
    accessKey: "consumptionandgenerationanalytics",
  },
  {
    path: "exchangeAnalysis",
    element: <NewDASHBOARDExchange />,
    noDefaultPadding: true,
  },
  {
    path: "powerAtlas",
    element: <PowerAtlas />,
    noDefaultPadding: true,
    accessKey: "poweratlas",
  },

  {
    path: "exchange-comparison",
    element: <ExchangeComparion />,
    notPrtoected: true,
  },
  {
    path: "exchange-comparison2",
    element: <ExchangeComparion2 />,
  },
  {
    path: "priceForecasting",
    element: <PriceForecastWrapper />,
    noDefaultPadding: true,
    accessKey: "priceforecasting",
  },
  // {
  //   path: "priceIndex",
  //   element: <PriceIndexWrapper />,
  //   noDefaultPadding: true,
  // },
  {
    path: "gas",
    element: <GasPage />,
    noDefaultPadding: true,
  },
  {
    path: "rajasthan",
    element: <Rajasthan />,
    noDefaultPadding: true,
  },

  {
    path: "demandForecasting",
    element: <DemandForecast />,
    noDefaultPadding: true,
    accessKey: "demandforecasting",
  },
  {
    path: "gridFrequencyProfile",
    element: {},
  },
  {
    path: "betaConsumption",
    element: <BetaConsumption />,
    notProtected: true,
  },
  {
    path: "auctions",
    element: <AuctionPage />,
    noDefaultPadding: true,
  },
  {
    path: "trader",
    element: <MainTraderComponent />,
    notProtected: false,
    noDefaultPadding: true,
  },
  {
    path: "MarketDerivativePage",
    element: <MarketDerivativePage />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "powerAnalysis",
    element: <PowerAnalyticsIndex />,
    noDefaultPadding: true,
  },
];

export const RajasthanRoutes = [
  {
    path: "upload",
    element: <UploadComponent />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "compare",
    element: <RajasthanOverview />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "procurementTable",
    element: <RajProcurement />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "generation",
    element: <RajGeneration />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "demand",
    element: <RajDemand />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "procurement",
    element: <RajPowerProcurement />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "automation",
    element: <RajAutomation />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "auctions",
    element: <RajAuctionPage />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "exchangeAnalysis",
    element: <NewRUVNLExchange />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "exchangemetrics",
    element: <ExchangeMetricsPage />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "agent/history",
    element: <AgentHistory />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "merit_engine",
    element: <MeritEngineRuvnlRouter />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "optimizer",
    element: <GnaOptimizerRuvnl />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "procurementOptimization",
    element: <ProcurementRuvnlOptimization />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
];
export const ChhattisgarhRoutes = [
  {
    path: "upload",
    element: <UploadComponent />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "compare",
    element: <RajasthanOverview />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "procurementTable",
    element: <RajProcurement />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "generation",
    element: <RajGeneration />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "demand",
    element: <CgsDemand />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "realtime",
    element: <CgsRealtime />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "procurement",
    element: <RajPowerProcurement />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "automation",
    element: <RajAutomation />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "auctions",
    element: <RajAuctionPage />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "exchangeAnalysis",
    element: <NewCGSExchange />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "exchangemetrics",
    element: <ExchangeMetricsPage />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "agent/history",
    element: <AgentHistory />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "merit_engine",
    element: <MeritEngineCgsRouter />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "optimizer",
    element: <GnaOptimizerRuvnl />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "procurementOptimization",
    element: <ProcurementRuvnlOptimization />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
];

export const DemoRoutes = [
  {
    path: "procurementOptimization",
    element: <ProcurementDemoOptimization />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "merit_engine",
    element: <MeritEngineDemoRouter />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "optimizer",
    element: <GnaOptimizerDemo />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "upload",
    element: <DemoUploadComponent />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "compare",
    element: <DemoRajasthanOverview />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "procurementTable",
    element: <DemoRajProcurement />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "generation",
    element: <DemoRajGeneration />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "demand",
    element: <DemoRajDemand />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "procurement",
    element: <DemoRajPowerProcurement />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "automation",
    element: <DemoRajAutomation />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "auctions",
    element: <DemoRajAuctionPage />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "exchangeAnalysis",
    element: <NewDEMOExchange />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "exchangemetrics",
    element: <ExchangeMetrics />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
];

export const GridcoRoutes = [
  {
    path: "optimizer",
    element: <GnaOptimizerGridco />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "procurementOptimization",
    element: <ProcurementGridcoOptimization />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "merit_engine",
    element: <MeritEngineGridcoRouter />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "uploadFile",
    element: <UploadFile />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "compare",
    element: <GridcoOverviewTab />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "demand",
    element: <GridcoDemand />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "upload",
    element: <Gridco />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "genration",
    element: <GridcoGenration />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "procurement",
    element: <GridcoPowerProcurement />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "automation",
    element: <Automation />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "exchangeAnalysis",
    element: <NewGRIDCOExchange />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "automation/bid-automation",
    element: <GridcoNetSchedule />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "automation/dam-performance",
    element: <DamPerformanceUpload />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "download_data",
    element: <DownloadDataWrapper />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
];

export const HppcRoutes = [
  {
    path: "demand",
    element: <HppcDemand />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "exchangeAnalysis",
    element: <NewHPPCExchange />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "overview",
    element: <HaryanaOverview />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "demand",
    element: <HppcDemand />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "Surplus",
    element: <SurplusDeficity />,
    noDefaultPadding: true,
    notPrtoected: true,
  },

  {
    path: "procurement",
    element: <HppcProcurement />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "overview",
    element: <HaryanaOverview />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "weather_forecast",
    element: <HppcWeather />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
];

export const JvvnlRoutes = [
  {
    path: "forecast",
    element: <JvvnlForecast />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
  {
    path: "overview",
    element: <JvvnlOverviewTab />,
    noDefaultPadding: true,
    notPrtoected: true,
  },
];
